import React from "react";
import CrmPayoutRequests from "../CrmPayoutRequests";

function CrmSbpPayoutRequests(props) {
    return <CrmPayoutRequests {...props} payoutType="sbp" />;
}

export default CrmSbpPayoutRequests;



// WEBPACK FOOTER //
// ./src/PagesOfAdministrator/CrmSbpPayoutRequests/index.js